import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { GlobalContext } from "../context";
import { link } from "fs";

function Merchandise() {
  const navigate = useNavigate();
  const { 
    activeHref, setActiveHref,
  } = useContext(GlobalContext);

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={<Header variant="h1"> Merchandise </Header>}
          >
            <Container
              header={<Header variant="h1"> Merchandise </Header>}
            >
              Active href: {activeHref}
            </Container>
            
          </ContentLayout>
        </div>
      </center>
    </>    
  );
}

export default Merchandise;
